import { render, staticRenderFns } from "./CoiRequests.vue?vue&type=template&id=67f13840&"
import script from "./CoiRequests.vue?vue&type=script&lang=js&"
export * from "./CoiRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports